export const CIVIL_MATTER_CASE = 'Civil Matter';
export const EVICTION_MATTER_CASE = 'Eviction Matter';
